import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=2ac81546"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"
import style0 from "./Fees.vue?vue&type=style&index=0&id=2ac81546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports